import close from '../Images/close.png';
import fileUpload from '../Images/fileUpload.png';
import donorCreate from '../Images/donorCreate.png'; // https://fontawesome.com/license added '+' to heartbeat icon
import defaultProfile from '../Images/defaultProfile.png';
import profileCircle from '../Images/profileCircle.png';
import circledDefaultProfile from '../Images/circledDefaultProfile.png';
import brokenMedia from '../Images/brokenMedia.png';
import iconSearch from '../Images/iconSearch.png';
import fileIcon from '../Images/fileIcon.png';
import videoIcon from '../Images/videoIcon.png';
import xvivoSymbol from '../Images/xvivoSymbol.png';
import xvivoSymbolSvg from '../Images/xvivoSymbolSvg.svg';
import xvivoFlowhawkLogo from '../Images/xvivoFlowhawkLogo.svg';
import appLogo from '../Images/xvivo-flowhawk-logo.svg';

const images = {
  close,
  fileUpload,
  defaultProfile,
  profileCircle,
  circledDefaultProfile,
  brokenMedia,
  iconSearch,
  fileIcon,
  videoIcon,
  donorCreate,
  xvivoSymbol,
  xvivoSymbolSvg,
  xvivoFlowhawkLogo,
  appLogo,
};

export default images;
